import React from 'react';

const SpecificSituations = () => {
  return (
    <>
      {/* Specific Situations */}
      <h3 className="text-2xl font-bold text-gray-800 mb-6">Specific Situations</h3>
      
      <div className="mb-8">
        <h4 className="text-xl font-semibold text-gray-800 mb-4">Agent orchestration and multi-step workflows</h4>
        <p className="text-gray-700 leading-relaxed mb-4">
          ASI1 models excel at coordinating complex autonomous workflows. For optimal results in multi-agent systems:
        </p>
        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mb-4">
          <ul className="space-y-2 text-gray-700">
            <li>• Define clear agent roles and responsibilities</li>
            <li>• Specify coordination protocols between agents</li>
            <li>• Include fail-safe mechanisms and rollback procedures</li>
            <li>• Establish clear success and failure criteria</li>
          </ul>
        </div>
      </div>

      <div className="mb-8">
        <h4 className="text-xl font-semibold text-gray-800 mb-4">DeFi protocol integration and management</h4>
        <p className="text-gray-700 leading-relaxed mb-4">
          When working with DeFi protocol integrations, provide comprehensive context about:
        </p>
        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mb-4">
          <ul className="space-y-2 text-gray-700">
            <li>• Protocol-specific requirements and interfaces</li>
            <li>• Smart contract interaction patterns</li>
            <li>• Gas fee optimization strategies</li>
            <li>• Security considerations and validation steps</li>
          </ul>
        </div>
      </div>

      <div className="mb-8">
        <h4 className="text-xl font-semibold text-gray-800 mb-4">Risk management and safety protocols</h4>
        <p className="text-gray-700 leading-relaxed mb-4">
          For financial and trading applications, establish clear boundaries:
        </p>
        <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200 mb-4">
          <ul className="space-y-2 text-gray-700">
            <li>• Maximum exposure limits per trade or position</li>
            <li>• Stop-loss and take-profit mechanisms</li>
            <li>• Market volatility thresholds for halting operations</li>
            <li>• Regulatory compliance checkpoints</li>
          </ul>
        </div>
      </div>

      <div className="mb-12">
        <h4 className="text-xl font-semibold text-gray-800 mb-4">Performance optimization techniques</h4>
        <p className="text-gray-700 leading-relaxed mb-4">
          To maximize ASI1's effectiveness in autonomous operations:
        </p>
        <div className="bg-green-50 p-6 rounded-lg border border-green-200 mb-4">
          <ul className="space-y-2 text-gray-700">
            <li>• Use structured output formats for consistent parsing</li>
            <li>• Implement incremental decision-making steps</li>
            <li>• Provide clear success metrics and KPIs</li>
            <li>• Include historical context for pattern recognition</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default SpecificSituations;
